/**
 * Calculates the max windowed sum of Activities per position
 * within a specified Template duration.
 *
 * @param duration - Total duration in positions. (e.g. 80)
 * @param activitiesPerPosition - An object containing activities per position. (eg. { 5: [], 8: [] ... })
 * @param window - The number of position to calculate sum. (e.g. 3)
   @returns The maximum number of activities within the window.
 */
export function calculateMaxWindowedActivitiesSumForTemplate(
  duration: number,
  activitiesPerPosition: Record<number, unknown[]>,
  window: number,
): number {
  let maxValue = -Infinity;
  let currentRunningSum = 0;

  const positionsArray = new Array(duration).fill(0).map((_, i) => i + 1);

  for (let i = 0; i < positionsArray.length; i++) {
    // add the number of activities at current position to the running sum
    currentRunningSum += activitiesPerPosition[i]?.length || 0;

    if (i >= window - 1) {
      maxValue = Math.max(maxValue, currentRunningSum);
      // remove the leftmost position of (the window) from the running sum
      currentRunningSum -= activitiesPerPosition[i - (window - 1)]?.length || 0;
    }
  }

  return maxValue;
}
